import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleBuyPanel = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    price: {
      decimal: '',
      string: '',
      currency: ''
    },
    sku: '',
    requestedRecipe: '',
    storedRecipes: [],
    itemsToPurchase: [ { size: '', quantity: 1 } ],
    ugcSize: null,
    isUGCApplied: null,
    showShareInStore: false,
    cartImage: null
  }
};

export default moduleBuyPanel;
